import { render, staticRenderFns } from "./rolesDel.vue?vue&type=template&id=0fdbee3d&scoped=true&"
import script from "./rolesDel.vue?vue&type=script&lang=js&"
export * from "./rolesDel.vue?vue&type=script&lang=js&"
import style0 from "./rolesDel.vue?vue&type=style&index=0&id=0fdbee3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdbee3d",
  null
  
)

export default component.exports